import {SERVICE_API} from '../utils/Const';
import {config} from '../utils/Const';

export class ApiClient {
    static sessionExpiredCallback;

    static getInstance(baseUrl) {
        return createApiClient(baseUrl);
    }

    static setSessionExpiredCallback(callback) {
        ApiClient.sessionExpiredCallback = callback;
    }

    constructor(baseUrl = config.BASE_URL) {
        this.baseUrl = baseUrl;
    }

    async login(user, region) {
        const url = this.getEndpointUrl(SERVICE_API.login);
        //let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');
        //console.log('LocalStorage',localShoppingCart);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({user,region})
                //body: JSON.stringify({user,localShoppingCart})
            },
            'ztoken'
        );
        return response;
    }

    async loginSeller(user) {
        const url = this.getEndpointUrl(SERVICE_API.seller);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({user})
            },
            'ztoken'
        );
        return response;
    }

    async loginousr(user) {
        const url = this.getEndpointUrl(SERVICE_API.loginousr);
        //let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');
        //console.log('LocalStorage',localShoppingCart);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({user})
                //body: JSON.stringify({user,localShoppingCart})
            },
            'ztoken'
        );
        return response;
    }

    async listClient(user, buscar) {
        const url = this.getEndpointUrl(SERVICE_API.listClient);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({user, buscar})
            },
            'ztoken'
        );
        return response;
    }

    async searchClient(user, nextNum) {
        const url = this.getEndpointUrl(SERVICE_API.searchClient);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({user, nextNum})
            },
            'ztoken'
        );
        return response;
    }

    async searchItems(item) {
        const url = this.getEndpointUrl(SERVICE_API.searchItems);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({item})
            },
            'ztoken'
        );
        return response;
    }

    async searchConditions(data) {
        const url = this.getEndpointUrl(SERVICE_API.searchConditions);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }

    async getPromo(datos) {
        const url = this.getEndpointUrl(SERVICE_API.getPromo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({datos})
            },
            'ztoken'
        );
        return response;
    }

    async getPromocionales(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPromocionales);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }
   
    async getBonificacion(data) {
            const url = this.getEndpointUrl(SERVICE_API.getBonificacion);
            const response = await apiFetchWithSession(
                url,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({data})
                },
            );
            return response;
        }
    async getPriceList(){
        const url = this.getEndpointUrl(SERVICE_API.getPriceList);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getPromocion(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPromocion);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }
    
    async getPromocionDisparador(data) {
        const url = this.getEndpointUrl(SERVICE_API.getPromocionDisparador);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }

    async getConditions(data) {
        const url = this.getEndpointUrl(SERVICE_API.getConditions);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }

    async disparadorVolumen(data) {
        const url = this.getEndpointUrl(SERVICE_API.tipoDisparadorVol);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }

    async disparadorMonto(data) {
        const url = this.getEndpointUrl(SERVICE_API.tipoDisparadorMonto);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }

    async insertPromo(data) {
        const url = this.getEndpointUrl(SERVICE_API.insertPromo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }

    async updatePromo(data) {
        const url = this.getEndpointUrl(SERVICE_API.updatePromo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }

    async aprobarPromo(data) {
        const url = this.getEndpointUrl(SERVICE_API.aprobarPromo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }

    async activarPromo(data) {
        const url = this.getEndpointUrl(SERVICE_API.activarPromo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
            'ztoken'
        );
        return response;
    }

    async register(register) {
        const url = this.getEndpointUrl(SERVICE_API.register);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(register)
            },
            'ztoken'
        );
        return response;
    }

    async getCategories() {
        const url = this.getEndpointUrl(SERVICE_API.getCategories);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getCategoriesHome() {
        const url = this.getEndpointUrl(SERVICE_API.getCategoriesHome);//Poder consultar el url, la ruta de la funcion en el back
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    async getProductsHome() {
        const url = this.getEndpointUrl(SERVICE_API.getProductsHome);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getBannerHome() {
        const url = this.getEndpointUrl(SERVICE_API.getBannerHome);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getProfile() {
        const url = this.getEndpointUrl(SERVICE_API.getProfile);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
            
        );
        return response;
    }

    async getAutorizaciones(user, type) {
        const url = this.getEndpointUrl(SERVICE_API.getAutorizaciones);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({user, type})
                //body: JSON.stringify({user,localShoppingCart})
            },
        );
        return response;
    }

    async getRegistroPedidos(data) {
        const url = this.getEndpointUrl(SERVICE_API.getRegistroPedidos);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
                //body: JSON.stringify({user,localShoppingCart})
            },
        );
        return response;
    }


    async getAutorizacionesCanalModerno(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAutorizacionesCanalModerno);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
                //body: JSON.stringify({user,localShoppingCart})
            },
        );
        return response;
    }

    async getCreateCanalModerno(data) {
        const url = this.getEndpointUrl(SERVICE_API.getCreateCanalModerno);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
                //body: JSON.stringify({user,localShoppingCart})
            },
        );
        return response;
    }
    
    async searchByKey(key, shoppingCart = undefined,page,seller,typeSearch) { // role = null, category
        const url = this.getEndpointUrl(SERVICE_API.searchByKey + '/' + key  + (shoppingCart ? ('?shoppingCartPublic=' + JSON.stringify(shoppingCart)) +'&' : '?')+'nextNum='+page +'&seller='+seller+'&typeSearch='+typeSearch);//+'&category='+category
        
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async searchByCategory(category, shoppingCart = undefined,page,seller) {
        const url = this.getEndpointUrl(SERVICE_API.searchByCategory + '/' + category  + (shoppingCart ? ('?shoppingCartPublic=' + JSON.stringify(shoppingCart)) +'&' : '?') +'&nextNum='+page+'&seller='+seller);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async openPublicBanner() {
        const url = SERVICE_API.getBanners;
        const urlas = this.getEndpointUrl(url);
        //console.log(urlas, newItem);
        const response = await apiFetchWithSession(
            urlas,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async openAdminBanner() {
        const url = SERVICE_API.getBanners;
        const urlas = this.getEndpointUrl(url);
        //console.log("here",urlas);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                //body: JSON.stringify(item),
            },
        );
        //console.log("OH no",response);
        return response;
    }

    async openItemDetails(ItemCode, shoppingCart = undefined) {
        let newItem = encodeURIComponent(ItemCode);
        const url = SERVICE_API.openItemDetails + '/' + newItem + (shoppingCart ? ('?shoppingCartPublic=' + JSON.stringify(shoppingCart)) : '');
        const urlas = this.getEndpointUrl(url);
        //console.log(urlas, newItem);
        const response = await apiFetchWithSession(
            urlas,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async updateFavorite(item) {
        const url = this.getEndpointUrl(SERVICE_API.updateFavorite + '/' + item.favorite);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(item),
            },
        );
        return response;
    }

    async updateAddress(addresses) {
        //console.log('Addreses EndPoint',addresses);
        const url = this.getEndpointUrl(SERVICE_API.updateAddresses);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({addresses}),
            },
        );
        return response;
    }

    async updateShoppingCart(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateShoppingCart);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async updateShoppingCartLocal(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateShoppingCarLocal);
        //console.log('IniciarSesion',data);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data}),
            },
        );
        return response;
    }

    async updateBackOrder(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateBackOrder);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async deleteShoppingCart(data) {
        const url = this.getEndpointUrl(SERVICE_API.deleteShoppingCart);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async deleteBackOrder(data) {
        const url = this.getEndpointUrl(SERVICE_API.deleteBackOrder);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            },
        );
        return response;
    }

    async getShoppingCart(shoppingCart) {
        const url = this.getEndpointUrl(SERVICE_API.getShoppingCart);
        let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');
        //localShoppingCart = {localstorage : JSON.parse(localShoppingCart)};
        //console.log('LocalStorage',localShoppingCart);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({shoppingCart,localShoppingCart})
            },
        );
        return response;
    }

    async createDocument(data) {
        const url = this.getEndpointUrl(SERVICE_API.createDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async createQuotation(data) {
        const url = this.getEndpointUrl(SERVICE_API.createQuotation);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async createPreliminar(data) {
        const url = this.getEndpointUrl(SERVICE_API.createPreliminar);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async createDelivery(data) {
        const url = this.getEndpointUrl(SERVICE_API.createDelivery);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async createAutorization(data) {
        const url = this.getEndpointUrl(SERVICE_API.createAutorization);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async rejectedAutorization(data) {
        const url = this.getEndpointUrl(SERVICE_API.rejectedAutorization);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    // async canalModerno(data) {
    //     const url = this.getEndpointUrl(SERVICE_API.canalModerno);
    //     const response = await apiFetchWithSession(
    //         url,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify(data)
    //         },
    //     );
    //     return response;
    // }


    async createSavedCart(data) {
        const url = this.getEndpointUrl(SERVICE_API.createSavedCart);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getCountries() {
        const url = this.getEndpointUrl(SERVICE_API.getCountries);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async validateMiddleware() {
        const url = this.getEndpointUrl(SERVICE_API.validateMiddleware);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                // headers: {
                //     'Content-Type': 'application/json',
                // },
            },
        );
        return response;
    }

    async Middleware(id){
        const url = this.getEndpointUrl(SERVICE_API.middleware + id);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
        return response;
    }

    async getCFDI() {
        const url = this.getEndpointUrl(SERVICE_API.getCFDI);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getFlete() {
        const url = this.getEndpointUrl(SERVICE_API.getFlete);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDescuento(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDescuento);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;        
    }

    async getNotifyOrder() {
        const url = this.getEndpointUrl(SERVICE_API.notifyOrders);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
            },
        );
        return response;
    }

    async getOrders(fechaInicio,fechaFinal) {
        const url = this.getEndpointUrl(SERVICE_API.getOrders + '/'+ fechaInicio  + '/'+  fechaFinal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
////////////////////////////
    async getOrdersSeller(data) {
        const url = this.getEndpointUrl(SERVICE_API.getOrdersSeller);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: data
            },
        );
        return response;
    }

    async getQuotation() {
        const url = this.getEndpointUrl(SERVICE_API.getQuotation);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDelivery() {
        const url = this.getEndpointUrl(SERVICE_API.getDelivery);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getSaveds() {
        const url = this.getEndpointUrl(SERVICE_API.getSaveds);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    async getPreliminarys(fechaInicio,fechaFinal) {
        const url = this.getEndpointUrl(SERVICE_API.getPreliminarys+ '/'+ fechaInicio  + '/'+  fechaFinal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    
    async getCollections(fechaInicio,fechaFinal) {
        const url = this.getEndpointUrl(SERVICE_API.getCollections+ '/'+ fechaInicio  + '/'+  fechaFinal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getOverdueOne() {
        const url = this.getEndpointUrl(SERVICE_API.getOverdueOne);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    async getOverdueTwo() {
        const url = this.getEndpointUrl(SERVICE_API.getOverdueTwo);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    async getOverdueThree() {
        const url = this.getEndpointUrl(SERVICE_API.getOverdueThree);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    async getOverdueFour() {
        const url = this.getEndpointUrl(SERVICE_API.getOverdueFour);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    async getOverdueFIve() {
        const url = this.getEndpointUrl(SERVICE_API.getOverdueFive);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    async getDataProfiel() {
        const url = this.getEndpointUrl(SERVICE_API.getDataProfiled);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }


    async getBills(fechaInicio,fechaFinal) {
        const url = this.getEndpointUrl(SERVICE_API.getBillings+ '/'+ fechaInicio  + '/'+  fechaFinal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getProductsDash() {
        const url = this.getEndpointUrl(SERVICE_API.getProdutcsDashBoard);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getOrder(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getOrder + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDataBill(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDataBillings + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDataQuotation(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDataQuotation + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    async getDataDelivery(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDataDelivery + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    async getDataPreliminary(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDataPreliminarys + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDataProduct(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDataProduct + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    async getDataProduct2(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDataProduct);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:docEntry
            },
        );
        return response;
    }

    async getDatailsAuto(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDatailsAuto + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDatailsAutoCanalModerno(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDatailsAutoCanalModerno);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async updateCart(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateCart);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getDataDocuemt(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDataDocument);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(docEntry)
            },
        );
        return response;
    }

    async getOrderDetails(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getOrdersDetails + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getStates(country) {
        const url = this.getEndpointUrl(SERVICE_API.getStates + '/' + country);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    static async getSessionToken() {
        return await localStorage.getItem(config.general.localStorageNamed + 'Token');
    }

    static async getBusiness() {
        return await localStorage.getItem(config.general.localStorageNamed + 'Business');
    }

    async updatePartner(data) {
        const url = this.getEndpointUrl(SERVICE_API.updatePartner);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async detailsSeller(profile) {
        const url = this.getEndpointUrl(SERVICE_API.detailsSeller + '/' + profile);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async updateSeller(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateSeller);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
    
    async detailsAutorizator(profile) {
        const url = this.getEndpointUrl(SERVICE_API.detailsAutorizator + '/' + profile);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async updateAutorizator(data) {
        const url = this.getEndpointUrl(SERVICE_API.updateAutorizator);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getAutoCartSaveds(data) {
        const url = this.getEndpointUrl(SERVICE_API.getAutoCartSaveds);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
        );
        return response;
    }

    async createCartSaved(data) {
        const url = this.getEndpointUrl(SERVICE_API.createCartSaved);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }

    async getCreditNotes(fechaInicio,fechaFinal) {
        const url = this.getEndpointUrl(SERVICE_API.getCreditNotes + '/'+ fechaInicio  + '/'+  fechaFinal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDataCreditNotes(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDataCreditNotes + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDebitNotes(fechaInicio,fechaFinal) {
        const url = this.getEndpointUrl(SERVICE_API.getDebitNotes + '/'+ fechaInicio  + '/'+  fechaFinal);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDataDebitNotes(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDataDebitNotes + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getStatusAccount(fechaInicio,fechaFinal,DocDate,OnlyUnreconciled) {
        const url = this.getEndpointUrl(SERVICE_API.getStatusAccount + '/'+ fechaInicio  + '/'+  fechaFinal + '/'+  DocDate + '/'+  OnlyUnreconciled);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDatagetStatusAccount(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDatagetStatusAccount + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    getEndpointUrl(urlPath) {
        return this.baseUrl + urlPath;
    }

    async getCartSaveds(data) {
        const url = this.getEndpointUrl(SERVICE_API.getCartSaveds);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
        );
        return response;
    }

    async getDetailsCartSaveds(data) {
        const url = this.getEndpointUrl(SERVICE_API.getDetailsCartSaveds);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
        );
        return response;
    }

    async getOrderStatus(data) {
        const url = this.getEndpointUrl(SERVICE_API.getOrderStatus);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({data})
            },
        );
        return response;
    }

    async getDetailsOrderStatus(docEntry) {
        const url = this.getEndpointUrl(SERVICE_API.getDetailsOrderStatus + '/' + docEntry);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    
    async getPriceCanalModerno() {
        const url = this.getEndpointUrl(SERVICE_API.getPriceCanalModerno);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }
    
    async detailsprofile(profile) {
        const url = this.getEndpointUrl(SERVICE_API.detailsprofile + '/' + profile);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async deleteCartSaved(id) {
        const url = this.getEndpointUrl(SERVICE_API.deleteCartSaved + '/' + id);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getDocumentsCM() {
        const url = this.getEndpointUrl(SERVICE_API.getDocumentsCM);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'GET',
            },
        );
        return response;
    }

    async getUserFields(data) {
        const url = this.getEndpointUrl(SERVICE_API.getUserFields);
        const response = await apiFetchWithSession(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            },
        );
        return response;
    }
}

export function createApiClient(baseUrl) {
    return new ApiClient(baseUrl);
}

async function apiFetch(url, init) {
    try {
        //console.log('Fetching url: ', url, init);

        const rawResponse = await fetch(url, init);
        //console.log('raw response: ', rawResponse);

        const response = await rawResponse.json();
        //console.log('api response: ', response);

        evaluateSessionExpiredResponse(response);
        return response;
    } catch (e) {
        //console.log(e);
        return {
            status: 0,
            message: 'Verifique su Internet o bien si persiste el error comuníquese con el área de TIC',e,
        };
    }
}

async function apiFetchWithSession(url, init, optionalToken = undefined) {
    let token;

    if (!optionalToken) {
        token = await ApiClient.getSessionToken();
    } else {
        token = optionalToken;
    }

    /*if (!token) {
        const response = {
            status: -10,
            message: 'No hay una sesión activa',
            data: {},
        };

        evaluateSessionExpiredResponse(response);

        return response;
    }*/

    if (init) {
        init.headers = {
            ...init.headers,
            Business: config.general.business,
        };

        if (token) {
            init.headers = {
                ...init.headers,
                Authorization: token || undefined,
            };
        }

    }

    //console.log(init.headers);
    return apiFetch(url, init);
}

function evaluateSessionExpiredResponse(response) {
    if (response.status < 0) {
        if (ApiClient.sessionExpiredCallback) {
            ApiClient.sessionExpiredCallback(response);
        }
    }
}
